<template>
  <div>
    <page-section :title="$t('Integrations_Title_Information')">
      <form-section
        v-loading="lastSyncDataLoading"
        :description="$t('Integrations_Text_LastSync')"
      >
        <span class="sync-date">
          {{
            lastSyncData !== null
              ? lastSyncDate
              : $t('Integrations_Text_NotSet')
          }}
        </span>
      </form-section>
    </page-section>

    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['meta_audiences_sync']"
    />
  </div>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectTimezoneDate } from '@/core/helpers'

export default {
  name: 'MetaOverview',

  components: {
    PageSection,
    FormSection,
    IntegrationTasksTable
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      lastSyncData: null,
      lastSyncDataLoading: false
    }
  },

  mounted() {
    if (this.model.id) {
      this.lastSyncDataLoading = true
      let asyncDateEndpoint = projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: {
          sort: '-create_time',
          integration_id: this.model.id,
          'per-page': 1
        }
      })
      RestApi(asyncDateEndpoint)
        .then(({ data }) => {
          if (data.length > 0) {
            this.lastSyncData = data[0].create_time
          }
          this.lastSyncDataLoading = false
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.lastSyncDataLoading = false
        })
    }
  },

  computed: {
    lastSyncDate() {
      return projectTimezoneDate(this.lastSyncData).format(
        'DD MMM YYYY HH:mm:ss'
      )
    }
  }
}
</script>

<style scoped>
.sync-date {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/meta/MetaOverview.vue